import React, { useEffect, useRef } from 'react';
import { JSONEditor } from '@json-editor/json-editor';
import './JsonEditorWrapper.css';

export const JsonEditorWrapper = ({ schema, value, onChange }) => {
  const containerRef = useRef(null);
  const editorRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && schema && Object.keys(schema.properties || {}).length > 0) {
      if (editorRef.current) {
        editorRef.current.destroy();
      }
      
      editorRef.current = new JSONEditor(containerRef.current, {
        schema: schema,
        startval: value,
        theme: 'bootstrap4',
        disable_edit_json: true,
        disable_properties: true,
        disable_collapse: false,
        collapsed: true,
        no_additional_properties: true,
      });

      const updateHighlights = () => {
        if (!editorRef.current) return;
        try {
          const currentVal = editorRef.current.getValue();
          if (!currentVal) return;
          Object.keys(currentVal).forEach(key => {
            // Do not highlight or add a badge to property configuration tables
            if (key.endsWith('_properties') || key.endsWith('Properties')) return;

            const path = `root.${key}`;
            // Use querySelectorAll to find the header in case it's nested differently
            const cardEl = containerRef.current.querySelector(`[data-schemapath="${path}"]`);
            if (cardEl) {
              // Find the button or the span containing the title
              const btnEl = cardEl.querySelector('button.json-editor-btn-collapse');
              const titleSpan = cardEl.querySelector('span, label, h3, h4, h5');
              
              if (btnEl || titleSpan) {
                const count = Array.isArray(currentVal[key]) ? currentVal[key].length : 0;
                const targetEl = btnEl || titleSpan;
                
                if (count > 0) {
                  if (btnEl) btnEl.classList.add('has-data-btn');
                  if (titleSpan) titleSpan.classList.add('has-data-header');
                  
                  let badge = targetEl.parentElement.querySelector('.data-count-badge');
                  if (!badge) {
                    badge = document.createElement('span');
                    badge.className = 'data-count-badge';
                    targetEl.parentElement.appendChild(badge);
                  }
                  badge.innerText = ` (${count})`;
                } else {
                  if (btnEl) btnEl.classList.remove('has-data-btn');
                  if (titleSpan) titleSpan.classList.remove('has-data-header');
                  const badge = targetEl.parentElement.querySelector('.data-count-badge');
                  if (badge) badge.remove();
                }
              }
            }
          });
        } catch (e) {
          // ignore
        }
      };

      editorRef.current.on('ready', () => {
        if (editorRef.current && value) {
          try {
            const currentVal = editorRef.current.getValue();
            if (JSON.stringify(currentVal) !== JSON.stringify(value)) {
              editorRef.current.setValue(value);
            }
          } catch (e) {
            console.warn('Failed to set initial value', e);
          }
        }
        updateHighlights();
      });

      editorRef.current.on('change', () => {
        if (editorRef.current) {
          try {
            onChange(editorRef.current.getValue());
            updateHighlights();
          } catch (e) {
            // Ignore if getValue fails (e.g., during destruction)
          }
        }
      });
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
        editorRef.current = null;
      }
    };
  }, [schema]);

  useEffect(() => {
    if (editorRef.current && value) {
      try {
        const currentVal = editorRef.current.getValue();
        if (JSON.stringify(currentVal) !== JSON.stringify(value)) {
          editorRef.current.setValue(value);
        }
      } catch (e) {
        console.warn('JSON Editor not ready to get/set value', e);
      }
    }
  }, [value]);

  return <div className="shapya-json-editor" ref={containerRef} />;
};
